// src/lib/firebase.ts
'use client'; // Mark as a client component

import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';
// import { getFirestore } from 'firebase/firestore'; // If you use Firestore
// import { getStorage } from 'firebase/storage'; // If you use Storage

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};
let isAppMailboxInitialized = false;

// Initialize Firebase
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const microsoftProvider = new OAuthProvider('microsoft.com');
microsoftProvider.setCustomParameters({ tenant: 'common' });
microsoftProvider.addScope('User.Read');
// const db = getFirestore(app); // If you use Firestore
// const storage = getStorage(app); // If you use Storage

const appMailBox = (() => {
  if (isAppMailboxInitialized) return getApp('mailBox');
  isAppMailboxInitialized = true;
  return initializeApp(firebaseConfig, 'mailBox');
})();
const authMailBox = getAuth(appMailBox);

export { app, auth, googleProvider, microsoftProvider, appMailBox, authMailBox /*, db, storage */ };
